import { convertFromRaw, convertToRaw, EditorState, Modifier  } from 'draft-js';
import {
    forwardRef,
    useEffect,
    useImperativeHandle,
    useState,
    useRef,
    useContext,
}  from 'react';
import { Card, Form } from 'react-bootstrap';
import "../../../../App/node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { Editor } from 'react-draft-wysiwyg';
import { useLocation,useNavigate } from 'react-router-dom';
import { useAuthentication, useQueryParams } from '../../Hooks';
import { ActividadesContext, ViewContext } from '../../Contexts';
import Select from 'react-select'
import {
    FUENTE_CASO,
    AtributosHelper,
    PANTALLA_EDIT,
    TIPO_SOLICITUDES_MI_CUENTA,
    TIPO_ENTRENAMIENTOS_MI_CUENTA
} from '../../Utils';
import { PantallaSimplebar } from '../../Componentes/PantallaSimpleBar/PantallaSimpleBar';
import useMessage from '../../Hooks/useMessage';
import useExceptionHandler from '../../Hooks/useExceptionHandler';
import { buscar } from '../../Utils/Buscar';
import EditSection from '../../Componentes/PantallasEdit/EditSection/EditSection';
import InputContainer from '../../Componentes/PantallasEdit/InputContainer/InputContainer';
import SectionRow from '../../Componentes/PantallasEdit/SectionRow/SectionRow';
import EditHeader from '../../Componentes/PantallasEdit/Header/EditHeader';
import EditContainer from '../../Componentes/PantallasEdit/EditContainer/EditContainer';
import Atributos from '../../Componentes/Atributos/Atributos';
import '../../Componentes/Chat/EnviarMensaje.styles.css'
import {ControlledInput} from "../../Componentes/Inputs/ControlledInput";
const SolicitudEdit = forwardRef(
    (
        {
            showLoading,
            hideLoading,
            esModal,
            estadoRef,
            idSec,
            fuente,
            referencia,
            cuentaIdSec,
            cuentaNombre,
            afterSave,
            setShowModalSimplebar,
        },
        ref
    ) => {
        const [caso, setCaso] = useState({
            Estatus: "A",
            Fecha: Date.now(),
            TipoSolicitud: 'E',
            TipoEntrenamiento: 'P'
        });
        const [tituloHeader, setTituloHeader] = useState("Crear Caso");

        const consultaActualId = useRef();
        const URLParameters = useQueryParams();
        const { Message, cerrarAlertas, Warning } = useMessage();
        const contactoRef = useRef(null);
        const { usuario } = useAuthentication();
        const { handleException } = useExceptionHandler();
        const cuentaLookupRef = useRef(null);
        
        const Id = esModal ? 0 : URLParameters.get("Id");
        const esClonar = URLParameters.get("Clonar") === "true";

        const [editorState, setEditorState] = useState(EditorState.createEmpty());
        const [esNuevo, setEsNuevo] = useState(true);
        const [simplebarName, setSimplebarName] = useState("");
        const [showCanvas, setShowCanvas] = useState(false);

        const uploadImageCallBack = (file) => {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();

                reader.onloadend = () => {
                    const base64Data = reader.result;
                    resolve({ data: { link: base64Data } });
                };

                reader.readAsDataURL(file);
            });
        };
        
        useEffect(() => {
            setEsNuevo(!Id || esClonar || esModal);
            if (idSec && esModal) {
                cargarCaso(idSec);
            }
            if (Id && !esModal) {
                showLoading();
                esClonar
                    ? setTituloHeader("Clonar Caso")
                    : setTituloHeader("Editar Caso");
            }
            return () => {
                hideLoading();
                cerrarAlertas();
            };
        }, [idSec]);
        
        const cargarDescripcion = (desc) => {
            if (desc) {
                setEditorState(
                    EditorState.createWithContent(convertFromRaw(JSON.parse(desc)))
                );
            }
        };

        const cargarCaso = (id) => {
        };
        const getTipoLabel = () => {
            switch (caso.TipoSolicitud){
                case "C":
                    return "Cancelacion de Servicio"
                case "AL":
                    return "Aumento de Licencia"
                case "DL":
                    return "Disminucion de Licencia"
                case "S":
                    return "Soporte"
                default:
                    return 'Entrenamiento'
            }
        }
        const grabar = async () => {
            showLoading();
            const consultaId = Math.random();
            consultaActualId.current = consultaId;
            const url = "/Seguridad/WebService/SeguridadWebService.asmx/CrearSolicitudMiCuenta";
            let nombre = "";
            if(caso?.TipoSolicitud === "E"){
                var tipoEntrenamiento= TIPO_ENTRENAMIENTOS_MI_CUENTA.find((tipo) => tipo.value === caso?.TipoEntrenamiento);
                var cantidadHoras = caso?.CantidadHoras  || (caso.TipoEntrenamiento === "R" ? "2" : "4")
                nombre = `[${usuario?.Compania?.Codigo.trim()}] ${cantidadHoras} HRS ${tipoEntrenamiento.label} - ${getTipoLabel()}`   
            } else{
                nombre = `[${usuario?.Compania?.Codigo.trim()}] - ${getTipoLabel()}`
            }

            const contentState = editorState.getCurrentContent();
            const selectionState = editorState.getSelection();
            const contentStateWithLineBreak = Modifier.insertText(contentState, selectionState, '\n');

            const contentStateWithText = Modifier.insertText(
                contentStateWithLineBreak,
                contentStateWithLineBreak.getSelectionAfter(),
                `Creado por usuario: ${usuario?.NombreUsuario}`  
            );
            const newEditorState = EditorState.push(editorState, contentStateWithText, 'insert-characters');
            buscar(url, { solicitud: 
                    {...caso,
                        NombreCaso: nombre, 
                        Descripcion: JSON.stringify(convertToRaw(newEditorState.getCurrentContent())),
                    } 
            }).then((data) => {
                if (consultaId === consultaActualId.current) {
                    Message({message: 'Solicitud Creada'});
                }
            }).catch((error) => {
                handleException(error);
            }).finally(() => {
                hideLoading();
            });
        };

        const limpiar = (limpiarLookUp) => {
            setEditorState(EditorState.createEmpty());
        };
        useImperativeHandle(ref, () => ({
            grabar,
            limpiar,
        }));

        const onEditorStateChange = (editorState) => {
            setEditorState(editorState);
        };
        const handleAfterSave = (id, name) => {
            switch (simplebarName) {
                case "prioridad":
                    setCaso({ ...caso, PrioridadIdSec: id });
                    break;
                case "equipo":
                    setCaso({
                        ...caso,
                        EquipoIdSecList: [...(caso.EquipoIdSecList || []), id],
                    });
                    break;
                case "razon":
                    setCaso({ ...caso, RazonAccionIdSec: id });
                    break;
                case "via-contacto":
                    setCaso({ ...caso, ViaContactoIdSec: id });
                    break;
                case "flujo-trabajo":
                    setCaso({ ...caso, FlujoTrabajoIdSec: id });
                    break;
                case "cuenta":
                    setCaso((prev) => ({
                        ...prev,
                        CuentaIdSecList: prev.CuentaIdSecList
                            ? [...prev.CuentaIdSecList, id]
                            : [id],
                    }));
                    cuentaLookupRef.current?.addToList({ label: name, value: id });
                    break;
                case "contacto":
                    setCaso((prev) => ({
                        ...prev,
                        ContactoIdSecList: prev.ContactoIdSecList
                            ? [...prev.ContactoIdSecList, id]
                            : [id],
                    }));
                    contactoRef.current?.addToList({ label: name, value: id });

                    break;
            }
            setShowCanvas(false);
        };
        return (
            <Form action="" className="form-horizontal" id="TypeValidation" method="">
                <EditHeader
                    titulo={`${tituloHeader}`}
                    volver={true}
                    grabar={grabar}
                    mostrarAcciones={Id && !esClonar}
                    showLoading={showLoading}
                    hideLoading={hideLoading}
                    fuente={FUENTE_CASO}
                    referencia={caso.IdSec}
                    tabla="Caso"
                    modulo="Caso"
                    esModal={esModal}
                    disabled={caso.Estatus === "C"}
                />
            <EditContainer disabled={caso.Estatus === "C"}>
{/*                <Atributos
                    fuente={FUENTE_CASO}
                    entidad={caso}
                    setEntidad={setCaso}
                    pantalla={PANTALLA_EDIT}
                />*/}
                <EditSection title="Información">
                    <SectionRow multilinea>
                        <InputContainer label="Tipo">
                            <Select
                                className="basic-single"
                                classNamePrefix="select"
                                name="Tipo Solicitud"
                                onChange={(e) => {
                                    setCaso({
                                        ...caso,
                                        TipoSolicitud: e.value,
                                    });
                                }}
                                options={TIPO_SOLICITUDES_MI_CUENTA}
                                value={
                                    esNuevo && !caso?.TipoSolicitud
                                        ? TIPO_SOLICITUDES_MI_CUENTA.filter(function (option) {
                                            return option.value === "E";
                                        })
                                        : TIPO_SOLICITUDES_MI_CUENTA.filter(function (option) {
                                            return option.value === (caso?.TipoSolicitud || "E");
                                        })
                                }
                            />
                        </InputContainer>
                    </SectionRow>
                    {caso?.TipoSolicitud === "E" && (
                        <>
                            <SectionRow multilinea>
                                <InputContainer label="Tipo Entrenamiento">
                                    <Select
                                        className="basic-single"
                                        classNamePrefix="select"
                                        name="Tipo Entranamiento"
                                        onChange={(e) => {
                                            setCaso({
                                                ...caso,
                                                TipoEntrenamiento: e.value,
                                            })
                                        }
                                        }
                                        options={TIPO_ENTRENAMIENTOS_MI_CUENTA}
                                        value={
                                            esNuevo && !caso?.TipoEntrenamiento
                                                ? TIPO_ENTRENAMIENTOS_MI_CUENTA.filter(function (option) {
                                                    return option.value === "P";
                                                })
                                                : TIPO_ENTRENAMIENTOS_MI_CUENTA.filter(function (option) {
                                                    return option.value === (caso?.TipoEntrenamiento || "P");
                                                })
                                        }
                                    />
                                </InputContainer>
                                <ControlledInput
                                    required
                                    label="Cantidad de Horas"
                                    name="CantidadHoras"
                                    type="number"
                                    setState={setCaso}
                                    min={caso.TipoEntrenamiento === "R" ? 2 : 4}
                                    value={caso?.CantidadHoras  || (caso.TipoEntrenamiento === "R" ? "2" : "4")}
                                />
                            </SectionRow>
                        </>
                    )}
                    <SectionRow multilinea>
                        <InputContainer label="Descripción">
                            <Editor
                                localization={{
                                    locale: "es",
                                }}
                                toolbar={{
                                    options: [
                                        "inline",
                                        "fontFamily",
                                        "list",
                                        "colorPicker",
                                        "link",
                                        "image",
                                        "history",
                                    ],
                                    blockType: {
                                        inDropdown: true,
                                        options: ["Normal"],
                                        className: undefined,
                                        component: undefined,
                                        dropdownClassName: undefined,
                                    },
                                    inline: {
                                        inDropdown: false,
                                        className: undefined,
                                        component: undefined,
                                        dropdownClassName: undefined,
                                        options: ["bold", "italic"],
                                    },
                                    image: {
                                        uploadEnabled: true,
                                        uploadCallback: uploadImageCallBack,
                                        alt: { present: true, mandatory: false },
                                        previewImage: true,
                                        inputAccept: "image/jpeg,image/jpg,image/png",
                                        defaultSize: {
                                            height: "auto",
                                            width: "400",
                                        },
                                    },
                                }}
                                editorState={editorState}
                                toolbarClassName="toolbarClassName"
                                wrapperClassName="wrapper-react-draft"
                                editorClassName="editor"
                                onEditorStateChange={(e) => {
                                    onEditorStateChange(e);
                                }}
                            />
                        </InputContainer>
                    </SectionRow>
                </EditSection>
            </EditContainer>  
                <PantallaSimplebar
                    name={simplebarName}
                    showCanvas={showCanvas}
                    setShowCanvas={setShowCanvas}
                    afterSave={handleAfterSave}
                    entidad="C"
                    cuentaIdSecList={null}
                />
            </Form>
        );
    }
);
export default SolicitudEdit;
